// extracted by mini-css-extract-plugin
module.exports = {"buttonTransparentNeutral":"ButtonTransparentNeutral_buttonTransparentNeutral__2gvaX"};